<template>
    <div>
        <!-- 
        为防止大图刷屏，每张图将强制放缩到最大高度200px。
        请自觉维护评论区的整洁，以免封号后又要重新注册等一个月的时间。
        超链接：[url]地址[/url]或[url=地址]文字[/url]，如[url]https://h5mota.com/[/url]或[url=https://h5mota.com/]H5魔塔网站[/url]。
        B站视频：[bilibili]//player.bilibili.com/...[/bilibili]。
        请插入分享的B站视频地址，必须是//player.bilibili.com/player.html?aid=数字(&bvid=...)&cid=数字&page=1的形式。
        插入视频的条件同插入图片。
        详细说明请参见<a href="http://bbs.17173.com/thread-11196009-1-1.html" target="_blank">此处</a>。 -->
        高级用法说明:<br/>
        <ul>
            <li>评论区支持emoji，如🙂🙃之类。（文明人，拒绝🐎）</li>
            <li>字体颜色：<code>[color=颜色]文字[/color]</code>，如<code>[color=red]红色[/color]</code>，<code>[color=#00FF00]绿色[/color]</code>。</li>
            <li>字体大小：<code>[size=大小]文字[/size]</code>，如<code>[size=20]字体大小20px[/size]</code>。</li>
            <li>网址：<code>[url]链接[/url]</code>或者<code>[url=xxx]介绍[/url]</code></li>
            <li>粗体和斜体：<code>[b]粗体文字[/b]</code>和<code>[i]斜体文字[/i]</code>。</li>
            <li>插入图片：<code>[img]图片地址[/img]</code>，如<code>[img]https://h5mota.com/favicon.ico[/img]</code>。<br/>
                这里暂不支持上传图片。如有需要，可移步论坛进行上传。
            </li>
        </ul>
        <div class="preview" v-html="parseText(text)"></div>
    </div>
</template>

<script>
import { parseText } from '../../../utils/utils';

export default {
    props: {
        text: String,
    },
    methods: {
        parseText,
    }
}
</script>

<style lang="less" scoped>
.preview {
    margin: 5px;
    padding: 5px;
    background-color: #DDDDDD;
    font-size: 16px;
    border-radius: 3px;
}
</style>